/* Price presentation only: never writes variant IDs, selling plans or cart inputs. */
(()=>{
 function start(){
  const source=document.getElementById('P2BundlePrices');if(!source||source.dataset.ready)return;
  let data;try{data=JSON.parse(source.textContent)}catch{return}source.dataset.ready='true';
  const money=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:data.currency||'USD'});
  let last='';
  function update(){
   const main=document.querySelector('[id^="MainProduct-"]'),picker=main?.querySelector('variant-radios');
   if(!picker)return;
   const fields=[...picker.querySelectorAll('fieldset')],bundle=fields.find(f=>[...f.querySelectorAll('input[type=radio]')].some(i=>/^\d+ BAGS?(?:\s|$)/i.test(i.value)));
   if(!bundle)return; // Odyssey uses a different purchase-option structure, not bag bundles.
   const options=fields.map(f=>f.querySelector('input:checked')?.value),position=fields.indexOf(bundle);
   const form=main.querySelector('form[data-type="add-to-cart-form"]');
   const hidden=form?.querySelector('input[type=hidden][name=selling_plan]');
   const widget=main.querySelector('.recharge-subscription-widget');
   const choice=widget?.querySelector('input[name=purchaseOption]:checked')?.value||
    (widget?.querySelector('.onetime-radio.rc-radio--active')?'onetime':widget?.querySelector('.subscription-radio.rc-radio--active')?'subscription':null);
   const legacy=main.querySelector('.sp_groups input[name=selling_plan]:checked');
   const plan=choice==='onetime'?'':hidden?.value||(choice==='subscription'?'pending':legacy?.value??data.initialPlan??'');
   const signature=JSON.stringify([options,plan,choice]);
   const summary=main.querySelector('.price');
   if(last===signature&&bundle.querySelector('.p2-bundle-price')&&(!summary||summary.querySelector('.p2-selected-price')))return;
   last=signature;
   for(const label of bundle.querySelectorAll('label[for]')){
    const input=document.getElementById(label.htmlFor);if(!input)continue;
    const variant=data.variants.find(v=>v.options.every((o,i)=>o===(i===position?input.value:options[i])));
    const allocation=variant?.allocations.find(a=>String(a.id)===String(plan));
    const subscribed=!!plan,availablePrice=variant&&(!subscribed||allocation);
    let block=label.querySelector('.p2-bundle-price');
    if(!block){
     // Keep the native label, option name and unavailable message; replace only old price artwork.
     for(const child of [...label.children])if(!child.matches('.p2-voyage-bundle-name,.visually-hidden'))child.classList.add('p2-bundle-legacy-price');
     block=document.createElement('span');block.className='p2-bundle-price';label.append(block);
    }
    block.replaceChildren();
    const row=document.createElement('span');row.className='p2-bundle-price__amounts';
    if(availablePrice){
     if(subscribed&&allocation.price<variant.price){const old=document.createElement('s');old.className='p2-bundle-price__was';old.textContent=variant.money;old.setAttribute('aria-label','Regular price '+variant.money);row.append(old)}
     const current=document.createElement('strong');current.className='p2-bundle-price__now';current.textContent=subscribed?allocation.money:variant.money;row.append(current);
    }
    const badge=document.createElement('span');badge.className='p2-bundle-price__kind';
    badge.textContent=!variant?'Unavailable in this flavor':!availablePrice?(plan==='pending'?'Updating price…':'Subscription unavailable'):subscribed?'Subscribe & save':'One-time price';
    block.dataset.subscription=String(subscribed);block.append(row,badge);
    if(availablePrice){
     const counts=input.value.match(/\d+/g),bags=counts?.reduce((total,n)=>total+Number(n),0);
     if(bags>1){const unit=document.createElement('span');unit.className='p2-bundle-price__unit';unit.textContent=money.format((subscribed?allocation.price:variant.price)/100/bags)+' / bag';block.append(unit)}
    }
   }

   if(summary){
    const selected=bundle.querySelector('input:checked');
    const label=selected?[...bundle.querySelectorAll('label[for]')].find(l=>l.htmlFor===selected.id):null;
    const block=label?.querySelector('.p2-bundle-price');
    if(block){
     const display=block.cloneNode(true);display.className='p2-selected-price';display.querySelector('.p2-bundle-price__unit')?.remove();
     summary.querySelector('.p2-selected-price')?.remove();summary.append(display);summary.classList.add('p2-price-summary');
    }
   }

  }
  const schedule=()=>requestAnimationFrame(update);
  document.addEventListener('change',schedule);document.addEventListener('phntm:preview-variant',schedule);
  window.addEventListener('w3-scripts-loaded',schedule);document.addEventListener('shopify:section:load',schedule);
  // Recharge can change hidden input.value without emitting a DOM mutation or change event.
  // Read the purchase state while visible; redraw only when its signature changes.
  setInterval(()=>{if(!document.hidden)update()},250);
  document.addEventListener('visibilitychange',schedule);update();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
